import React from 'react'
import styled from 'styled-components'
import { spacing } from '../styles/Rythms'

const SocialIcons = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  a {
    margin: 0 ${spacing[2]};
  }
`

const StyledSVG = styled.svg`
  transition-duration: 0.15s;

  &:hover {
    transform: translateY(-3px);
  }
`

export const Website = ({ size = 48 }) => (
  <StyledSVG
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="47" height="47" rx="6" fill="#1F2933" />
    <rect x="0.5" y="0.5" width="45" height="45" rx="4.5" fill="white" stroke="#1F2933" />
    <path
      d="M26.1252 11.1138L24.5343 12.7048C21.6174 15.6216 21.6174 20.3946 24.5343 23.3114C27.4511 26.2282 32.224 26.2282 35.1409 23.3114L36.7319 21.7204C39.6487 18.8036 39.6487 14.0306 36.7319 11.1138C33.815 8.19701 29.0421 8.19701 26.1252 11.1138ZM34.6105 19.5991L33.0195 21.1901C31.2695 22.9402 28.4057 22.9402 26.6556 21.1901C24.9055 19.44 24.9055 16.5762 26.6556 14.8261L28.2466 13.2351C29.9967 11.4851 32.8604 11.4851 34.6105 13.2351C36.3606 14.9852 36.3606 17.849 34.6105 19.5991Z"
      fill="#52606D"
    />
    <path
      d="M12.8665 24.3721L11.2755 25.9631C8.35865 28.8799 8.35865 33.6528 11.2755 36.5697C14.1923 39.4865 18.9653 39.4865 21.8821 36.5697L23.4731 34.9787C26.3899 32.0619 26.3899 27.2889 23.4731 24.3721C20.5562 21.4552 15.7833 21.4552 12.8665 24.3721ZM21.3517 32.8573L19.7608 34.4483C18.0107 36.1984 15.1469 36.1984 13.3968 34.4483C11.6467 32.6982 11.6467 29.8345 13.3968 28.0844L14.9878 26.4934C16.7379 24.7433 19.6017 24.7433 21.3517 26.4934C23.1018 28.2435 23.1018 31.1073 21.3517 32.8573Z"
      fill="#52606D"
    />
    <path
      d="M27.7157 18.008L18.1698 27.554C17.5864 28.1373 17.5864 29.0919 18.1698 29.6753C18.7532 30.2586 19.7077 30.2586 20.2911 29.6753L29.8371 20.1293C30.4204 19.546 30.4204 18.5914 29.8371 18.008C29.2537 17.4247 28.2991 17.4247 27.7157 18.008Z"
      fill="#9AA5B1"
    />
  </StyledSVG>
)

export const Linkedin = ({ size = 48 }) => (
  <StyledSVG
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="47" height="47" rx="6" fill="#1F2933" />
    <rect x="0.5" y="0.5" width="45" height="45" rx="4.5" fill="white" stroke="#1F2933" />
    <path
      d="M36.7857 8H10.2074C8.98951 8 8 9.00335 8 10.235V36.765C8 37.9967 8.98951 39 10.2074 39H36.7857C38.0036 39 39 37.9967 39 36.765V10.235C39 9.00335 38.0036 8 36.7857 8ZM17.3692 34.5714H12.7746V19.7772H17.3761V34.5714H17.3692ZM15.0719 17.7567C13.598 17.7567 12.4078 16.5596 12.4078 15.0926C12.4078 13.6257 13.598 12.4286 15.0719 12.4286C16.5388 12.4286 17.7359 13.6257 17.7359 15.0926C17.7359 16.5665 16.5458 17.7567 15.0719 17.7567V17.7567ZM34.5922 34.5714H29.9975V27.375C29.9975 25.6589 29.9629 23.4516 27.6103 23.4516C25.2161 23.4516 24.8493 25.3199 24.8493 27.2504V34.5714H20.2547V19.7772H24.6625V21.7978H24.7248C25.3406 20.6353 26.8422 19.4105 29.0772 19.4105C33.7272 19.4105 34.5922 22.4759 34.5922 26.4616V34.5714V34.5714Z"
      fill="#0E76A8"
    />
  </StyledSVG>
)

export const WhatsApp = ({ size = 48 }) => (
  <StyledSVG
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="47" height="47" rx="6" fill="#1F2933" />
    <rect x="0.5" y="0.5" width="45" height="45" rx="4.5" fill="white" stroke="#1F2933" />
    <path
      d="M9.00602 38L11.034 30.548C9.69773 28.2573 8.99566 25.652 9.00002 23C9.00002 14.7155 15.7155 8 24 8C32.2845 8 39 14.7155 39 23C39 31.2845 32.2845 38 24 38C21.3492 38.0043 18.745 37.3028 16.455 35.9675L9.00602 38ZM18.5865 15.962C18.3928 15.974 18.2035 16.025 18.03 16.112C17.8673 16.2041 17.7188 16.3193 17.589 16.454C17.409 16.6235 17.307 16.7705 17.1975 16.913C16.6431 17.6345 16.3449 18.5201 16.35 19.43C16.353 20.165 16.545 20.8805 16.845 21.5495C17.4585 22.9025 18.468 24.335 19.8015 25.6625C20.1225 25.982 20.436 26.303 20.7735 26.6015C22.4286 28.0587 24.4009 29.1096 26.5335 29.6705L27.387 29.801C27.6645 29.816 27.942 29.795 28.221 29.7815C28.6579 29.7589 29.0844 29.6407 29.4705 29.435C29.7195 29.303 29.8365 29.237 30.045 29.105C30.045 29.105 30.1095 29.063 30.2325 28.97C30.435 28.82 30.5595 28.7135 30.7275 28.538C30.852 28.409 30.96 28.2575 31.0425 28.085C31.1595 27.8405 31.2765 27.374 31.3245 26.9855C31.3605 26.6885 31.35 26.5265 31.3455 26.426C31.3395 26.2655 31.206 26.099 31.0605 26.0285L30.1875 25.637C30.1875 25.637 28.8825 25.0685 28.086 24.7055C28.002 24.6689 27.912 24.648 27.8205 24.644C27.7179 24.6335 27.6142 24.645 27.5164 24.6779C27.4186 24.7107 27.329 24.7641 27.2535 24.8345V24.8315C27.246 24.8315 27.1455 24.917 26.061 26.231C25.9988 26.3146 25.913 26.3779 25.8147 26.4126C25.7164 26.4473 25.61 26.452 25.509 26.426C25.4113 26.3999 25.3155 26.3668 25.2225 26.327C25.0365 26.249 24.972 26.219 24.8445 26.1635L24.837 26.1605C23.9789 25.7858 23.1844 25.2798 22.482 24.6605C22.293 24.4955 22.1175 24.3155 21.9375 24.1415C21.3474 23.5764 20.8331 22.937 20.4075 22.2395L20.319 22.097C20.2555 22.0012 20.2041 21.898 20.166 21.7895C20.109 21.569 20.2575 21.392 20.2575 21.392C20.2575 21.392 20.622 20.993 20.7915 20.777C20.9327 20.5975 21.0643 20.4107 21.186 20.2175C21.363 19.9325 21.4185 19.64 21.3255 19.4135C20.9055 18.3875 20.4705 17.366 20.0235 16.352C19.935 16.151 19.6725 16.007 19.434 15.9785C19.353 15.9695 19.272 15.9605 19.191 15.9545C18.9896 15.9445 18.7877 15.9465 18.5865 15.9605V15.962Z"
      fill="#25D366"
    />
  </StyledSVG>
)

export const Pocket = ({ size = 48 }) => (
  <StyledSVG
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="47" height="47" rx="6" fill="#1F2933" />
    <rect x="0.5" y="0.5" width="45" height="45" rx="4.5" fill="white" stroke="#1F2933" />
    <path
      d="M36.6594 10H10.8547C9.30078 10 8 11.3008 8 12.8547V22.3609C8 31.1289 15.0102 38.125 23.7641 38.125C32.4828 38.125 39.5 31.1289 39.5 22.3609V12.8547C39.5 11.2797 38.2555 10 36.6594 10V10ZM25.2688 28.8789C24.3969 29.7086 23.0609 29.6594 22.2875 28.8789C14.293 21.2219 14.2086 21.4891 14.2086 20.2164C14.2086 19.0281 15.1789 18.0578 16.3672 18.0578C17.5625 18.0578 17.4992 18.325 23.7641 24.3367C30.1344 18.2266 29.9938 18.0578 31.182 18.0578C32.3703 18.0578 33.3406 19.0281 33.3406 20.2164C33.3406 21.468 33.1367 21.3203 25.2688 28.8789V28.8789Z"
      fill="#C43446"
    />
  </StyledSVG>
)

export const Facebook = ({ size = 48 }) => (
  <StyledSVG
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="47" height="47" rx="6" fill="#1F2933" />
    <rect x="0.5" y="0.5" width="45" height="45" rx="4.5" fill="white" stroke="#1F2933" />
    <path
      d="M30.4538 25.0625L31.3669 19.0903H25.658V15.2147C25.658 13.5808 26.4554 11.9882 29.0123 11.9882H31.6076V6.90348C31.6076 6.90348 29.2524 6.5 27.0006 6.5C22.2991 6.5 19.226 9.36043 19.226 14.5386V19.0903H14V25.0625H19.226V39.5H25.658V25.0625H30.4538Z"
      fill="#1877F2"
    />
  </StyledSVG>
)

export const Instagram = ({ size = 48 }) => (
  <StyledSVG
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="47" height="47" rx="6" fill="#1F2933" />
    <rect x="0.5" y="0.5" width="45" height="45" rx="4.5" fill="white" stroke="#1F2933" />
    <path
      d="M23.0069 14.914C18.5351 14.914 14.928 18.5211 14.928 22.9929C14.928 27.4648 18.5351 31.0718 23.0069 31.0718C27.4788 31.0718 31.0858 27.4648 31.0858 22.9929C31.0858 18.5211 27.4788 14.914 23.0069 14.914ZM23.0069 28.2453C20.1171 28.2453 17.7546 25.8898 17.7546 22.9929C17.7546 20.0961 20.1101 17.7406 23.0069 17.7406C25.9038 17.7406 28.2593 20.0961 28.2593 22.9929C28.2593 25.8898 25.8968 28.2453 23.0069 28.2453V28.2453ZM33.3007 14.5836C33.3007 15.6312 32.4569 16.4679 31.4163 16.4679C30.3686 16.4679 29.5319 15.6242 29.5319 14.5836C29.5319 13.5429 30.3757 12.6992 31.4163 12.6992C32.4569 12.6992 33.3007 13.5429 33.3007 14.5836ZM38.6515 16.4961C38.5319 13.9718 37.9554 11.7359 36.1061 9.89372C34.264 8.05154 32.028 7.47498 29.5038 7.34841C26.9022 7.20076 19.1046 7.20076 16.503 7.34841C13.9858 7.46794 11.7499 8.04451 9.90068 9.88669C8.05146 11.7289 7.48193 13.9648 7.35537 16.489C7.20771 19.0906 7.20771 26.8883 7.35537 29.4898C7.4749 32.014 8.05146 34.25 9.90068 36.0922C11.7499 37.9343 13.9788 38.5109 16.503 38.6375C19.1046 38.7851 26.9022 38.7851 29.5038 38.6375C32.028 38.5179 34.264 37.9414 36.1061 36.0922C37.9483 34.25 38.5249 32.014 38.6515 29.4898C38.7991 26.8883 38.7991 19.0976 38.6515 16.4961V16.4961ZM35.2905 32.2812C34.7421 33.6593 33.6804 34.7211 32.2952 35.2765C30.221 36.0992 25.2991 35.9093 23.0069 35.9093C20.7147 35.9093 15.7858 36.0922 13.7186 35.2765C12.3405 34.7281 11.2788 33.6664 10.7233 32.2812C9.90068 30.207 10.0905 25.2851 10.0905 22.9929C10.0905 20.7008 9.90771 15.7718 10.7233 13.7047C11.2718 12.3265 12.3335 11.2648 13.7186 10.7093C15.7929 9.88669 20.7147 10.0765 23.0069 10.0765C25.2991 10.0765 30.228 9.89372 32.2952 10.7093C33.6733 11.2578 34.735 12.3195 35.2905 13.7047C36.1132 15.7789 35.9233 20.7008 35.9233 22.9929C35.9233 25.2851 36.1132 30.214 35.2905 32.2812Z"
      fill="#C32AA3"
    />
  </StyledSVG>
)

export const Twitter = ({ size = 48 }) => (
  <StyledSVG
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="47" height="47" rx="6" fill="#1F2933" />
    <rect x="0.5" y="0.5" width="45" height="45" rx="4.5" fill="white" stroke="#1F2933" />
    <path
      d="M36.6662 18.3896C36.6853 18.6561 36.6853 18.9227 36.6853 19.1891C36.6853 27.3173 30.4987 36.6828 19.1916 36.6828C15.7081 36.6828 12.4721 35.6738 9.75 33.9227C10.2449 33.9797 10.7208 33.9988 11.2348 33.9988C14.1091 33.9988 16.7551 33.028 18.868 31.3719C16.165 31.3148 13.8997 29.5445 13.1193 27.1079C13.5 27.165 13.8807 27.2031 14.2805 27.2031C14.8325 27.2031 15.3846 27.1269 15.8985 26.9937C13.0812 26.4226 10.9682 23.948 10.9682 20.9594V20.8833C11.7867 21.3402 12.7386 21.6257 13.7474 21.6637C12.0913 20.5596 11.0063 18.6752 11.0063 16.5432C11.0063 15.4011 11.3108 14.3541 11.8438 13.4404C14.8705 17.1713 19.42 19.6078 24.5215 19.8744C24.4263 19.4175 24.3692 18.9417 24.3692 18.4658C24.3692 15.0774 27.1103 12.3173 30.5177 12.3173C32.288 12.3173 33.8869 13.0597 35.0101 14.2589C36.3996 13.9925 37.7321 13.4785 38.9123 12.7742C38.4554 14.2019 37.4846 15.4011 36.2093 16.1625C37.4466 16.0293 38.6459 15.6866 39.7499 15.2107C38.9125 16.429 37.8654 17.5139 36.6662 18.3896V18.3896Z"
      fill="#1DA1F2"
    />
  </StyledSVG>
)

export const Pinterest = ({ size = 48 }) => (
  <StyledSVG
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="47" height="47" rx="6" fill="#1F2933" />
    <rect x="0.5" y="0.5" width="45" height="45" rx="4.5" fill="white" stroke="#1F2933" />
    <path
      d="M40.625 23C40.625 32.6328 32.8203 40.4375 23.1875 40.4375C21.3875 40.4375 19.6578 40.1633 18.0266 39.657C18.7367 38.4969 19.7984 36.5984 20.1922 35.0867C20.4031 34.2711 21.275 30.9383 21.275 30.9383C21.8445 32.0211 23.5039 32.9422 25.2688 32.9422C30.5281 32.9422 34.318 28.1047 34.318 22.093C34.318 16.3344 29.6141 12.0242 23.5672 12.0242C16.0437 12.0242 12.043 17.0727 12.043 22.5781C12.043 25.1375 13.407 28.3227 15.5797 29.3352C15.9102 29.4898 16.0859 29.4195 16.1633 29.1031C16.2195 28.8641 16.5148 27.6758 16.6484 27.1273C16.6906 26.9516 16.6695 26.7969 16.5289 26.6281C15.8188 25.7492 15.2422 24.1461 15.2422 22.6484C15.2422 18.8023 18.1531 15.0828 23.1172 15.0828C27.3992 15.0828 30.4016 18.0008 30.4016 22.1773C30.4016 26.8953 28.018 30.1648 24.9172 30.1648C23.2086 30.1648 21.9219 28.7516 22.3367 27.0148C22.8289 24.9406 23.7781 22.7047 23.7781 21.207C23.7781 19.8711 23.0609 18.7531 21.5703 18.7531C19.8195 18.7531 18.4133 20.5602 18.4133 22.9859C18.4133 24.5328 18.9336 25.5734 18.9336 25.5734C18.9336 25.5734 17.2109 32.8719 16.8945 34.2359C16.543 35.7406 16.6836 37.8641 16.8313 39.2422C10.3484 36.7039 5.75 30.3898 5.75 23C5.75 13.3672 13.5547 5.5625 23.1875 5.5625C32.8203 5.5625 40.625 13.3672 40.625 23Z"
      fill="#BD081C"
    />
  </StyledSVG>
)

const Social = (props) => {
  const { theme, size } = props
  const facebook = 'https://www.facebook.com/moneylofr/'
  const instagram = 'https://www.instagram.com/moneylofr/'
  const pinterest = 'https://www.pinterest.fr/moneylofr/'
  const twitter = 'https://twitter.com/moneylofr/'

  return (
    <SocialIcons className={theme}>
      <a
        href={facebook}
        className="social-btn"
        data-social="facebook"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Facebook size={size} />
      </a>
      <a
        href={pinterest}
        className="social-btn"
        data-social="pinterest"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Pinterest size={size} />
      </a>
      <a
        href={twitter}
        target="_blank"
        className="social-btn"
        data-social="twitter"
        rel="noopener noreferrer"
      >
        <Twitter size={size} />
      </a>
      <a
        href={instagram}
        target="_blank"
        className="social-btn"
        data-social="instagram"
        rel="noopener noreferrer"
      >
        <Instagram size={size} />
      </a>
    </SocialIcons>
  )
}

export default Social
